const SERVER_DEFAULTS = {
    dev: {
        baseUrl: import.meta.env.VITE_BASE_URL_DEV || 'https://api.dev.newretail.avp.tech',
        webSocketUrl: 'wss://push.dev.newretail.avp.tech/ws',
        vmsUrl: 'https://tui.audi-vmrs.endava.berlin',
        supportEmail: 'support@vms.audi.de',
        authorizeEndpoint: 'https://auth.preprod.avp.tech/oauth2/authorize',
        tokenEndpoint: 'https://auth.preprod.avp.tech/oauth2/token',
        logoutEndpoint: 'https://auth.preprod.avp.tech/logout',
        clientId: '5a5j2uurnrvvkf3d889tlbis0r',
        avpPortal: 'https://portal.preprod.avp.tech',
        avpPortalNeRDPair: 'https://portal.preprod.avp.tech/#/retailDeviceManagement/nerdDeviceList',
        avpImprint: 'https://portal.preprod.avp.tech/#/imprint',
        avpLegal: 'https://portal.preprod.avp.tech/#/legal',
        pwaUrl: 'https://pwa.dev.newretail.avp.tech/?override=true'
    },
    int: {
        baseUrl: import.meta.env.VITE_BASE_URL_INT || 'https://api.int.newretail.avp.tech',
        webSocketUrl: 'wss://push.int.newretail.avp.tech/ws',
        vmsUrl: 'https://stage.audi-vmrs.endava.berlin',
        supportEmail: 'support@vms.audi.de',
        authorizeEndpoint: 'https://auth.preprod.avp.tech/oauth2/authorize',
        tokenEndpoint: 'https://auth.preprod.avp.tech/oauth2/token',
        logoutEndpoint: 'https://auth.preprod.avp.tech/logout',
        clientId: '5a5j2uurnrvvkf3d889tlbis0r',
        avpPortal: 'https://portal.preprod.avp.tech',
        avpPortalNeRDPair: 'https://portal.preprod.avp.tech/#/retailDeviceManagement/nerdDeviceList',
        avpImprint: 'https://portal.preprod.avp.tech/#/imprint',
        avpLegal: 'https://portal.preprod.avp.tech/#/legal',
        pwaUrl: 'https://pwa.int.newretail.avp.tech/?override=true'
    },
    prod: {
        baseUrl: import.meta.env.VITE_BASE_URL_PROD || 'https://api.prod.newretail.avp.tech',
        webSocketUrl: 'wss://push.prod.newretail.avp.tech/ws',
        vmsUrl: 'https://vms.audi.de',
        supportEmail: 'support@vms.audi.de',
        authorizeEndpoint: 'https://auth.avp.tech/oauth2/authorize',
        tokenEndpoint: 'https://auth.avp.tech/oauth2/token',
        logoutEndpoint: 'https://auth.avp.tech/logout',
        clientId: '1k6qi8q8n6agjvn5u90jbak5oj',
        avpPortal: 'https://portal.avp.tech',
        avpPortalNeRDPair: 'https://portal.avp.tech/#/retailDeviceManagement/nerdDeviceList',
        avpImprint: 'https://portal.avp.tech/#/imprint',
        avpLegal: 'https://portal.avp.tech/#/legal',
        pwaUrl: 'https://pwa.prod.newretail.avp.tech/?override=true'
    }
};

export const SERVER_CONFIGS = {
    audi: {
        dev: {
            ...SERVER_DEFAULTS.dev,
            webLogEnabled: true,
            channelSlug: 'a-digital-retail',
            privacyPolicyLocation: `${SERVER_DEFAULTS.dev.vmsUrl}/datenschutz`,
            systemSupport: 'https://collaboration.msi.audi.com/jira/plugins/servlet/theme/portal/51',
        },
        int: {
            ...SERVER_DEFAULTS.int,
            webLogEnabled: true,
            channelSlug: 'a-digital-retail',
            privacyPolicyLocation: `${SERVER_DEFAULTS.int.vmsUrl}/datenschutz`,
            systemSupport: 'https://collaboration.msi.audi.com/jira/plugins/servlet/theme/portal/51',
        },
        prod: {
            ...SERVER_DEFAULTS.prod,
            webLogEnabled: false,
            channelSlug: 'a-digital-retail',
            privacyPolicyLocation: `${SERVER_DEFAULTS.prod.vmsUrl}/datenschutz`,
            systemSupport: 'https://collaboration.msi.audi.com/jira/plugins/servlet/theme/portal/51',
        }
    },
    bentley: {
        dev: {
            ...SERVER_DEFAULTS.dev,
            webLogEnabled: true,
            channelSlug: 'e-digital-retail',
            privacyPolicyLocation: `${SERVER_DEFAULTS.dev.vmsUrl}/datenschutz`,
            systemSupport: 'https://collaboration.msi.audi.com/jira/plugins/servlet/theme/portal/51',
        },
        int: {
            ...SERVER_DEFAULTS.int,
            webLogEnabled: true,
            channelSlug: 'e-digital-retail',
            privacyPolicyLocation: `${SERVER_DEFAULTS.int.vmsUrl}/datenschutz`,
            systemSupport: 'https://collaboration.msi.audi.com/jira/plugins/servlet/theme/portal/51',
        },
        prod: {
            ...SERVER_DEFAULTS.prod,
            webLogEnabled: false,
            channelSlug: 'e-digital-retail',
            privacyPolicyLocation: `${SERVER_DEFAULTS.prod.vmsUrl}/datenschutz`,
            systemSupport: 'https://collaboration.msi.audi.com/jira/plugins/servlet/theme/portal/51',
        }
    },    
    cupra: {
        dev: {
            ...SERVER_DEFAULTS.dev,
            webLogEnabled: true,
            channelSlug: 's-digital-retail',
            privacyPolicyLocation: `${SERVER_DEFAULTS.dev.vmsUrl}/datenschutz`,
            systemSupport: 'https://collaboration.msi.audi.com/jira/plugins/servlet/theme/portal/51',
        },
        int: {
            ...SERVER_DEFAULTS.int,
            webLogEnabled: true,
            channelSlug: 's-digital-retail',
            privacyPolicyLocation: `${SERVER_DEFAULTS.int.vmsUrl}/datenschutz`,
            systemSupport: 'https://collaboration.msi.audi.com/jira/plugins/servlet/theme/portal/51',
        },
        prod: {
            ...SERVER_DEFAULTS.prod,
            webLogEnabled: false,
            channelSlug: 's-digital-retail',
            privacyPolicyLocation: `${SERVER_DEFAULTS.prod.vmsUrl}/datenschutz`,
            systemSupport: 'https://collaboration.msi.audi.com/jira/plugins/servlet/theme/portal/51',
        }
    },
    volkswagen: {
        dev: {
            ...SERVER_DEFAULTS.dev,
            channelSlug: 'v-digital-retail',
            systemSupport: 'https://collaboration.msi.audi.com/jira/plugins/servlet/theme/portal/51',
        },
        int: {
            ...SERVER_DEFAULTS.int,
            channelSlug: 'v-digital-retail',
            systemSupport: 'https://collaboration.msi.audi.com/jira/plugins/servlet/theme/portal/51',
        },
        prod: {
            ...SERVER_DEFAULTS.prod,
            channelSlug: 'v-digital-retail',
            systemSupport: 'https://collaboration.msi.audi.com/jira/plugins/servlet/theme/portal/51',
        }
    }
};

export const CLIENT_CONFIGS = {
    audi: {
        clientName: 'Audi',
        isOverrideEnabled: true,
        isPinPairingEnabled: true,
    },
    bentley: {
        clientName: 'Bentley',
        isOverrideEnabled: true,
        isPinPairingEnabled: true,
        // TODO: set url
        imprintURL: 'https://www.cupraofficial.com/legal-note',
        // TODO: set url
        privacyPolicyURL:
            'https://www.cupraofficial.com/privacy-policy'
    },    
    cupra: {
        clientName: 'SEAT CUPRA',
        isOverrideEnabled: false,
        isPinPairingEnabled: true,
        imprintURL: 'https://www.cupraofficial.com/legal-note',
        privacyPolicyURL:
            'https://www.cupraofficial.com/privacy-policy'
    },
    volkswagen: {
        clientName: 'Volkswagen',
        isOverrideEnabled: true,
        isPinPairingEnabled: true,
        imprintURL: 'https://cdn.dse.cloud.wholesaleservices.de/avp-impressum.html',
        privacyPolicyURL:
            'https://cdn.dse.cloud.wholesaleservices.de/vms-datenschutz.html'
    }
};
